import Layout from "../components/Layout";
import TableUsers from "../components/user-management/TableUsers";
import TableGroups from "../components/user-management/TableGroups";
import useUserManagementLogic from "../hooks/useUserManagementLogic";
import UserModals from "../components/user-management/UserModals";
import ModalSelectClient from "../components/user-management/ModalSelectClient";
import { useState } from "react";
function UserManagement() {
  const {
    showModal,
    setShowModal,
    selectedClient,
    setSelectedClient,
    availableClients,
    currentView,
    setCurrentView,
    activeModal,
    setActiveModal,
    users,
    setUsers,
    groups,
    setGroups,
    editUser,
    setEditUser,
    editGroup,
    setEditGroup,
    groupToDelete,
    setGroupToDelete,
    adminUser,
    handleSelectClient,
    handleCloseModal,
    handleAction,
    handleUpdateUser,
    handleCreateUser,
    handleUpdateGroup,
    handleDeleteGroup,
    groupsWithMemberCount,
    setCurrentPage,
    currentPage,
    allUsersCached,
    setAllUsersCached,
    allGroupsCached,
    setAllGroupsCached,
    selectedClientCode,
  } = useUserManagementLogic();
  const [filterName, setFilterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");

  const clientName = selectedClient || "...";
    // ✅ Verifica permessi
  const hasManagementPermissions = adminUser?.ROLES?.some(role => 
    role.Rol === 'ADMINISTRADOR' || role.Rol === 'GESTIONUSERS'
  );
  const normalizeText = (text) =>
    text
      ? text
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
      : "";
/*console.log('🔍 adminUser.USER:', adminUser?.USER);
console.log('🔍 users array completo:', users);
console.log('🔍 users.USER:', users.map(u => u.USER));
console.log('🔍 Confronto:', users.map(u => ({
  user: u.USER,
  match: u.USER === adminUser?.USER,
  adminUser: adminUser?.USER
})));
*/
  // ✅ Filtra utenti: se non hai permessi, vedi solo te stesso
  const visibleUsers = hasManagementPermissions 
    ? users 
    : users.filter(u => u.USER === adminUser?.USER);

     // console.log('🔍 visibleUsers:', visibleUsers.map(u => u.USER));
  // ✅ Nascondi gruppi se non hai permessi
  const canViewGroups = hasManagementPermissions;
  const handleApplyFilterName = () => {
  if (currentView === "usuarios") {
    if (!filterName.trim()) {
      setUsers(allUsersCached);
      return;
    }

    const filtered = allUsersCached.filter(u =>
      u.USER.toLowerCase().includes(filterName.toLowerCase())
    );
    setUsers(filtered);
  } 
  else if (currentView === "grupos") {
    if (!filterName.trim()) {
      setGroups(allGroupsCached);
      return;
    }

    const filtered = allGroupsCached.filter(g =>
      g.NOMBRE.toLowerCase().includes(filterName.toLowerCase())
    );
    setGroups(filtered);
  }
};

  const handleApplyFilterEmail = () => {
  if (currentView === "usuarios") {
    if (!filterEmail.trim()) {
      setUsers(allUsersCached);
      return;
    }

    const filtered = allUsersCached.filter(u =>
      u.EMAIL?.toLowerCase().includes(filterEmail.toLowerCase())
    );
    setUsers(filtered);
  } 
  else if (currentView === "grupos") {
    if (!filterEmail.trim()) {
      setGroups(allGroupsCached);
      return;
    }

    const searchTerm = normalizeText(filterEmail);
    const filtered = allGroupsCached.filter(g => {
      const activo =
        g.ACTIVO === "1" ||
        g.ACTIVO === 1 ||
        g.ACTIVO === true ||
        g.ACTIVO === "true"
          ? "si"
          : "no";

      return normalizeText(activo).includes(searchTerm);
    });
    setGroups(filtered);
  }
};

  const canChangeClient = (availableClients?.length || 0) > 0;

  const handleOpenClientModal = () => {
    if (!canChangeClient) return;
    setShowModal(true);
  };

  return (
    <Layout>
      {showModal && (
        <ModalSelectClient
          clients={availableClients}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          onSelect={handleSelectClient}
          onClose={handleCloseModal}
        />
      )}

      <UserModals
        activeModal={activeModal}
        setActiveModal={setActiveModal}
        showModal={showModal}
        handleSelectClient={handleSelectClient} // ✅
        handleCloseModal={handleCloseModal}
        selectedClient={selectedClient} // ✅
        setSelectedClient={setSelectedClient} // ✅
        availableClients={availableClients} // ✅ AGGIUNGI QUESTA
        editUser={editUser}
        setEditUser={setEditUser}
        editGroup={editGroup}
        setEditGroup={setEditGroup}
        groupToDelete={groupToDelete}
        setGroupToDelete={setGroupToDelete}
        groups={groups}
        adminUser={adminUser}
        users={users}
        setUsers={setUsers}
        handleUpdateUser={handleUpdateUser}
        handleCreateUser={handleCreateUser}
        handleUpdateGroup={handleUpdateGroup}
        handleDeleteGroup={handleDeleteGroup}
        setGroups={setGroups}
        allUsersCached={allUsersCached}
        setAllUsersCached={setAllUsersCached}
        setAllGroupsCached={setAllGroupsCached}
        hasManagementPermissions={hasManagementPermissions}
        selectedClientCode={selectedClientCode}
      />

      {!showModal && (
        <div className="dashboard">
          <div className="ventana mostrar">
            <span className="ventana_tittle">Gestión de Usuarios</span>
            <div className="ventana_menu">
              <div className="menu_descripcion">
                <span>
                  <b>Cliente:</b> {clientName || "Sin cliente"}
                </span>
                {/*<span>
                  <b>Usuarios</b>
                </span>*/}
              </div>
              <div className="menu_opciones">
                <span
                  className={`ficha ${!canChangeClient ? "disable" : ""}`}
                  onClick={handleOpenClientModal}
                  role="button"
                >
                  Cambiar cliente
                </span>
                <span
                  className={`ficha ${currentView === "usuarios" ? "active" : ""}`}
                  onClick={() => setCurrentView("usuarios")}
                >
                  Usuarios
                </span>
                <span
                  className={`ficha ${currentView === "grupos" ? "active" : ""}`}
                  onClick={() => setCurrentView("grupos")}
                >
                  Grupos
                </span>
              </div>
            </div>
            {hasManagementPermissions && (
            <div className="menu_busqueda">
              <div className="boton_filtro">
                <i className="bi bi-search"></i>
                <input
                    type="text"
                    placeholder={
                      currentView === "usuarios"
                        ? "Filtrar nombre de usuario"
                        : "Filtrar nombre de grupo"
                    }
                    value={filterName}
                    onChange={(e) => setFilterName(e.target.value)}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "inherit",
                      outline: "none",
                    }}
                  />
              </div>
              <span className="boton_cancelar" onClick={handleApplyFilterName}>
                Aplicar filtro
              </span>
              <div className="separador"></div>
              <div className="boton_filtro">
                <i className="bi bi-search"></i>
                <input
                    type="text"
                    placeholder={
                      currentView === "usuarios"
                        ? "Filtrar email de usuario"
                        : "Filtrar por estado"
                    }
                    value={filterEmail}
                    onChange={(e) => setFilterEmail(e.target.value)}
                    style={{
                      border: "none",
                      background: "transparent",
                      color: "inherit",
                      outline: "none",
                    }}
                  />
              </div>
              <span className="boton_cancelar" onClick={handleApplyFilterEmail}>
              Aplicar filtro
            </span>
            </div>
            )}
            {currentView === "usuarios" && (
              <TableUsers 
              users={visibleUsers} 
              onAction={handleAction} 
              hasManagementPermissions={hasManagementPermissions}
              />

            )}
            {currentView === "grupos" && (
              <TableGroups
                groups={groupsWithMemberCount}
                onAction={handleAction}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                hasManagementPermissions={hasManagementPermissions}
              />
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}

export default UserManagement;